<template lang="pug">
  .content-center
    .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0.page-title(@click="$helpers.redirect('')")
      .arrow-left
        i.fas.fa-chevron-left
      .modal-title.text-capitalize.pl-3 home
    .subtitle-wrap
      .bg-subtitle02
        .page-subtitle02 contact us
    .page-wrap02.page-contact-us
      .bg-contact
        .contact-top
          img.img-fluid(src="img/contact-top.png")
        .row.mx-0.contact-content(v-if="!isEmpty")
          template(v-for="(item, key, index) in contactList")
            .col-md-6.px-0.px-md-2.px-lg-3(v-if="item")
              a.d-flex.align-items-center.contact-single(v-if="key == 'wechat'" :href="'https://msng.link/o/?' + item + '=wc'" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-weixin
                .contact-detail
                  .text-white.contac-title Wechat
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'whatsapp'" :href="'https://wa.me/' + item" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-whatsapp
                .contact-detail
                  .text-white.contac-title WhatsApp
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'telegram'" :href="'https://t.me/' + item" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-telegram-plane
                .contact-detail
                  .text-white.contac-title Telegram
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'facebook'" :href="'https://www.facebook.com/' + item" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-facebook-f
                .contact-detail
                  .text-white.contac-title Facebook
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'instagram'" :href="'https://www.instagram.com/' + item" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-instagram
                .contact-detail
                  .text-white.contac-title Instagram
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'skype'" :href="'skype:' + item + '?chat'" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-skype
                .contact-detail
                  .text-white.contac-title Skype
                  .text-success.contact-id {{item}}
              a.d-flex.align-items-center.contact-single(v-else-if="key == 'line'" :href="'line://ti/p/~' + item" target="_blank")
                .text-white.contact-icon
                  i.fab.fa-line
                .contact-detail
                  .text-white.contac-title Line
                  .text-success.contact-id {{item}}
    footerInfo
</template>
<script>
import config from '@/config'
import errorTags from '@/errorTags'
import footerInfo from "@/views/default/_footer.vue";
export default {
  components:{
    footerInfo
  },
  data(){
    return{
      contactList: {},
      feedback: {
        status: "",
        success: ""
      }
    }
  },
  computed: {
    isEmpty() {
      var keys = Object.keys(this.contactList);
      for(var i = 0; i < keys.length; i++) {
        if(this.contactList[keys[i]]) {
          return false;
        }
      }
      return true;
    }
  },
  mounted(){
    this.getContactUsList();
  },
  methods:{
    getContactUsList() {
      if(this.$store.getters.accountID && this.$store.getters.sessionToken){
        var url = config.getContactUsList();
        var json = {
          account_id: this.$store.getters.accountID,
          app_id: config.app_id,
          auth_token: this.$store.getters.sessionToken
        };
      }else{
        var url = config.getContactUsListBeforeLogin();
        var json = {
          app_id: config.app_id,
        };
      }
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }

              this.feedback.status = response.status;

              if (this.feedback.success == true) {
                this.contactList = response.data.value[0];
                // var test = this.isEmpty;
              } else {
                var vm = this;
                if((typeof response.status) != 'object'){
                  this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            var vm = this;
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
            }
          }
        },
        function(response) {
          // this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this);
          }
        }
      );
    },
  }
}
</script>